import { useEffect, useState, useRef } from "react";
import { scrollToSection } from "@/lib/scroll";
import { TripResult } from "@/types/trip.types";

interface useAutoScrollProps {
  tripResult: TripResult | null;
  routePlotted: boolean;
  emissionsLoaded: Record<string, boolean>;
  tripVersion: number;
  initialAutoScrollEnabled?: boolean;
}

export function useAutoScroll({
  tripResult,
  routePlotted,
  emissionsLoaded,
  tripVersion,
  initialAutoScrollEnabled = true
}: useAutoScrollProps) {
  // State is now fully internal to the hook
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(initialAutoScrollEnabled);
  const resultsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!tripResult || !routePlotted) return;

    const allReady =
      Object.values(emissionsLoaded).length > 0 &&
      Object.values(emissionsLoaded).every(Boolean);

    if (allReady && autoScrollEnabled) {
      const timeout = setTimeout(() => {
        scrollToSection(resultsRef.current, { offset: 8, smooth: true });
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [tripResult, routePlotted, emissionsLoaded, autoScrollEnabled, tripVersion, resultsRef]);

  return { autoScrollEnabled, setAutoScrollEnabled, resultsRef };
}